import { useTheme } from "../context/ThemeContext";

export function TableWrap({ children }) {
  const { mode } = useTheme();
  return (
    <div style={{ background:"var(--surface)", border:`1px solid var(--border)`, borderRadius:9, overflow:"hidden" }}>
      <div style={{ overflowX:"auto" }}>
        <table style={{ width:"100%", borderCollapse:"collapse" }}>
          {children}
        </table>
      </div>
    </div>
  );
}

export function TH({ children }) {
  const { mode } = useTheme();
  return (
    <th style={{ padding:"9px 14px", textAlign:"left", fontSize:10, fontWeight:700, color:"var(--text-dim)", textTransform:"uppercase", letterSpacing:"0.07em", whiteSpace:"nowrap", borderBottom:`1px solid var(--border)`, background:"var(--surface-alt)" }}>
      {children}
    </th>
  );
}

export function TD({ children, mono, sub, style: s }) {
  const { mode } = useTheme();
  return (
    <td style={{ padding:"10px 14px", fontSize:12, color: sub ? "var(--text-sub)" : "var(--text)", fontFamily: mono ? "'IBM Plex Mono', monospace" : "inherit", borderBottom:`1px solid var(--border)`, ...s }}>
      {children}
    </td>
  );
}
